import { Component, Host, h, Prop, Event, Listen, EventEmitter } from '@stencil/core';
import IconBubbleFilled  from '../../../assets/images/svg/Bubble_Filled.svg';
import IconBubble  from '../../../assets/images/svg/Bubble.svg';
import Supercard_01  from '../../../assets/images/svg/Supercard_01.svg';
import Checkbox_01  from '../../../assets/images/svg/Checkbox_01.svg';
import PickUp  from '../../../assets/images/svg/pickup--white.svg';
@Component({
  tag: 'lilu-icon',
  styleUrl: 'lilu-icon.scss',
  shadow: true,
})
export class LiluIcon {

  @Prop() type = '';
  @Prop() color = 'nero';
  @Prop() size = '';
  @Prop() border = '';
  @Prop() backgroundcolor = '';
  @Prop() appearance = '';

  @Event() clickLiluIcon: EventEmitter<object>;

  clickLiluIconHandler(evt: object) {
    this.clickLiluIcon.emit(evt);
  }

  @Listen('click')
  handleEvent(e) {
    this.clickLiluIconHandler(e);
  }

  render() {
    return (
      <Host class={`${this.size} ${this.appearance}`} part={`${this.size}`}>
        {
          this.type === 'icon-bubble-filled' ||
          this.type === 'icon-bubble' ||
          this.type === 'icon-supercard-01' ||
          this.type === 'icon-checkbox-01' ||
          this.type === 'icon-pickup'
            ? <span part='span' style={{'background-color': `var(--${this.backgroundcolor})`}}
                  class={`svg-container ${this.size} ${this.type} ${this.border} ${this.color}`}
                  innerHTML={this.getInlineSVGByType()} >
            </span>
          : <span part='span' style={{'background-color': `var(--${this.backgroundcolor})`}}
                  class={`icon ${this.type} ${this.border} size ${this.color}`}>
            </span>
        }
      </Host>
    );
  }

  getInlineSVGByType(): any {
    switch(this.type) {
      case 'icon-bubble-filled':
        return IconBubbleFilled;

      case 'icon-bubble':
        return IconBubble;

      case 'icon-supercard-01':
        return Supercard_01;

      case 'icon-checkbox-01':
        return Checkbox_01;

      case 'icon-pickup':
        return PickUp;
    }
    return null;
  }

}

